<template>
    <div class="head_all">
      <div class="head_nei">
        <div class="head_q">
      <div class="head_logo"><img src="../assets/ykb_logo.png" alt="" class="logo"></div>

      <div class="head_menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color = "#0f3780">

              <el-menu-item :index="item.headIndex.content" v-for="item in itemData.content.menuData">
                <router-link :to="item.headPath.content">
                  <li class="header_li">{{item.headText.content}}</li>
                </router-link></el-menu-item>


    </el-menu>

      </div>
        </div>
      <div class="head_sn">
        <div class="tbp">
          <img src="../assets/image/ss1.png"  alt="" class="zy" @click="choice()">
        </div>
        <div  class="tbp_1" v-show="itemData.content.showimg" v-for="item in itemData.content.language" @click="checkM(item.path.content)">{{item.text1.content}}</div>

      </div>
      </div>
  </div>

</template>
<script>
import { Data } from './js/header.js';
export default {
  data() {
    return {
      dataAll:Data,
      itemData:{},
      activeIndex:"1",
    }
  },
  name: "hearder",
  mounted() {
    let that = this;
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type+11);
      console.log(that.$parent.message)
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }

    let urlData = that.$route.path;
    console.log(urlData);
    console.log(that.itemData.content.menuData)
    for(let item in that.itemData.content.menuData){
      let itemData =  that.itemData.content.menuData[item]
      if(urlData == itemData.headPath){
        that.itemData.content.activeIndex = itemData.headIndex;
      }
    }

  },
  methods: {
    choice() {
      let that = this;
      if (that.itemData.content.showimg) {
        that.itemData.content.showimg = false;
      } else {
        that.itemData.content.showimg = true;
      }
    },
    checkM(path) {
      let that = this;

      let urlData = that.$route.path;
      let urlAll = window.location.href;
      let param = "";
      if(urlAll.indexOf("?") > 0){
        param = urlAll.substring(urlAll.indexOf("?"));
      }
      console.log(param);
      console.log(path);
      let old = that.$parent.message;
      that.$parent.message = path;
      that.itemData.content.showimg = false;
      if ('zh' == path) {
        if(old == 'en') {
          console.log(urlData)
          console.log(urlData.length)

          this.$router.push({
            path: urlData+param,
            query: {
              _t: new Date().getTime() // 添加时间戳
            }
          });

        }
      } else {
        if(old == 'zh') {
          console.log(urlData)
          this.$router.push({
            path: urlData+param,
            query: {
              _t: new Date().getTime() // 添加时间戳
            }
          });
        }
      }
      console.log(that.$parent.message + "12345")
    },
    choiceEn() {
      let that = this;
      console.log(that.$parent.message+"333")
      for(let index in that.dataAll){
        let itemData= that.dataAll[index];
        if(that.$parent.message == itemData.type){
          that.itemData = itemData;
          break;
        }
      }
    },
  },
  // watch: {
  //   $route(to, from) {
  //     let that = this;
  //     let path = to.path;
  //     let headItem = that.itemData.content.menuData;
  //     console.log("path" + path)
  //     console.log(headItem)
  //     for (let item in headItem) {
  //       let itemData = headItem[item]
  //       if (path == itemData.headPath) {
  //         console.log("head:" + itemData.headIndex)
  //         that.activeIndex = itemData.headIndex;
  //       }
  //     }
  //
  //   }
  // }
}
</script>
<style scoped>
.tbp_1{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  height: 35px;
  width: 70px;
  cursor: pointer;
}
.tbp{
  display: flex;
  width: 70px;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid #409eff;
}
.logo{
  width: 108px;
  height: 38px;
}
.head_logo{
  margin-right: 40px;
  display: flex;
  align-items: center;
}
.head_sn{
  display: block;
  align-items: center;
  justify-content: right;
  margin-right: 10px;
  z-index: 100;
}
.zy{
  width: 20px;
  height: 20px;
}
.head_all{
  width: 100%;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
}
.header_li{
  font-family: SourceHanSansCN;
}
.head_q{
  display: flex;
  height: 100%;

}
.head_nei{
  /*width: 62%;*/
  height: 100%;
  display: flex;
  background-color: #FFFFFF;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/components/hearder.vue